// eslint-disable-next-line import/prefer-default-export
export const formProductIcons = [
    {
        title: 'Guarantee Icons',
        code: 'guarantee',
        desc:
            'The following icons will be associated with guarantee and cancel policies. Check the box if you’d like the guarantee policy icon and label shown on the product card with the rate.',
        formElements: [
            {
                elements: [
                    {
                        code: 'freeCancellation',
                        iconName: 'check',
                        title: 'Free Cancellation (shown even if cancellation is free for a limited time)'
                    },
                    {
                        code: 'holdAvailable',
                        iconName: 'check',
                        title: 'Hold Available (No Deposit Required)'
                    },
                    {
                        code: 'depositRequired',
                        iconName: 'credit-card',
                        title: 'Deposit Required'
                    },
                    {
                        code: 'guaranteedWithCreditCard',
                        iconName: 'credit-card',
                        title: 'Guaranteed with Credit Card'
                    },
                    {
                        code: 'instantHold',
                        iconName: 'lightning-bolt',
                        title: 'Today Only! Book Now, Pay Later.'
                    }
                ]
            }
        ]
    },
    {
        title: 'Meal Plan Icons',
        code: 'mealPlan',
        desc:
            'The following icons will be associated with meal plans. If meal plans are set up for the rate in Control Center and the icon is checked, the icon and label will show with the room rate.',
        formElements: [
            {
                elements: [
                    {
                        desc: [
                            'RMA: buffet breakfast (160); meal included - breakfast (189); meal included - continental breakfast (190); meal included - full american breakfast (199);\n',
                            'maps to  meal plan: Bed & Breakfast (BB); Bermuda (BP); Breakfast (BK); Light Breakfast (LB); Buffet Breakfast (BF); Caribbean Plan (CB); Continental (CP), English Breakfast (EB); Full Breakfast (FB);'
                        ],
                        code: 'breakfastIncluded',
                        iconName: 'coffee',
                        title: 'Breakfast Included'
                    },
                    {
                        desc: 'maps to meal plan: Modifed American (MA)',
                        code: 'breakfastDinnerIncluded',
                        iconName: 'food',
                        title: 'Breakfast and Dinner Included'
                    },
                    {
                        desc: 'maps to meal plan: Dinner Bed and Breakfast (BD)',
                        code: 'dinnerIncluded',
                        iconName: 'food',
                        title: 'Dinner Included'
                    },
                    {
                        desc: 'maps to meal plan: All Inclusive (AI); American/Full Board (AP)',
                        code: 'allMealsIncluded',
                        iconName: 'food',
                        title: 'All Meals Included'
                    },
                    {
                        desc: 'maps to meal plan: Family (FP); Family American (FA)',
                        code: 'discountedMealsForChildren',
                        iconName: 'food',
                        title: 'Discounted Meals for Children'
                    }
                ]
            }
        ]
    },
    {
        title: 'Room Amenity Icons (Select Up to 8)',
        code: 'roomAmenity',
        desc:
            'The following icons will be associated with room amenities selected in Control Center. If the icon is checked AND the amenity is associated with the room in Control Center, it will show on the product card.',
        formElements: [
            {
                title: 'Accessible Features',
                code: 'accessibleFeatures',
                elements: [
                    {
                        desc:
                            'RMA: grab bars in bathroom (48), accessible room (161), bathtub seat (181), handicap room (221), or marked ADA Compliant in Control Center',
                        code: 'accessibleRoom',
                        iconName: 'handicap',
                        title: 'Accessible Room'
                    }
                ]
            },
            {
                title: 'Air Quality',
                code: 'airQuality',
                elements: [
                    {
                        desc:
                            'RMA: air conditioning (2); air conditioning individually controlled in room (126); self-controlled heating/cooling system (166);',
                        code: 'airConditioning',
                        iconName: 'hotel-ac',
                        title: 'Air Conditioning'
                    },
                    {
                        code: 'nonSmoking',
                        iconName: 'smoking-non',
                        title: 'Non-smoking'
                    },
                    {
                        code: 'smoking',
                        iconName: 'smoking',
                        title: 'Smoking'
                    }
                ]
            },
            {
                title: 'Bathroom',
                code: 'bathroom',
                elements: [
                    {
                        desc:
                            'RMA: bath tub with spray jets (9), bathtub (13), bathtub/shower combination (15); bathtub only (14); Bathtub & jacuzzi separate (127), oversized bathtub (141); hinoki tub (244);',
                        code: 'bathtub',
                        iconName: 'hotel-bathtub',
                        title: 'Bathtub'
                    },
                    {
                        code: 'hairDryer',
                        iconName: 'hotel-blow-dryer',
                        title: 'Hair Dryer'
                    },
                    {
                        desc: 'RMA: shower only (97); shower (142); separate tub and shower (155);',
                        code: 'shower',
                        iconName: 'hotel-shower',
                        title: 'Separate Shower'
                    }
                ]
            },
            {
                title: 'Internet Services (best to select one)',
                code: 'internetServices',
                elements: [
                    {
                        desc:
                            'RMA: wireless internet connection (123); complimentary high speed internet in room (207); high speed wireless (226);',
                        code: 'freeWifi',
                        iconName: 'wifi',
                        title: 'Free Wifi'
                    },
                    {
                        desc: 'RMA: high speed internet connection (51);',
                        code: 'highSpeedInternet',
                        iconName: 'wifi',
                        title: 'High Speed Internet'
                    }
                ]
            },
            {
                title: 'Kitchen and Kitchen Equipment',
                code: 'kitchen',
                elements: [
                    {
                        desc: 'RMA: full kitchen (47); kitchen (59); kitchenette (61)',
                        code: 'kitchenArea',
                        iconName: 'hotel-kitchen',
                        title: 'Kitchen Area'
                    },
                    {
                        code: 'microwave',
                        iconName: 'hotel-microwave',
                        title: 'Microwave'
                    },
                    {
                        desc: 'RMA: refrigerator (88); refrigerator with icemaker (89); mini-refrigerator (164);',
                        code: 'refrigerator',
                        iconName: 'hotel-refrigerator',
                        title: 'Refrigerator'
                    }
                ]
            },
            {
                title: 'Pets',
                code: 'pets',
                elements: [
                    {
                        desc:
                            'RMA: pets allowed (140); non-refundable charge for pets (153); refundable deposit for pets (154);',
                        code: 'petsAllowed',
                        iconName: 'pet-paw',
                        title: 'Pets Allowed'
                    }
                ]
            },
            {
                title: 'Workspaces, Comfort & Security',
                code: 'workspacesComfortSecurity',
                elements: [
                    {
                        code: 'deskOrWorkspace',
                        desc:
                            'Desk (RMA 28); Desk with lamp (RMA 29); Ergonomic chair (RMA 36); Large desk (RMA 64); Large work area (RMA 65); Desk with electrical outlet (RMA 133); Spare electrical outlet available at desk (RMA 152); Chair provided with desk (RMA 230)',
                        iconName: 'hotel-lamp-desk',
                        title: 'Desk or Workspace'
                    },
                    {
                        code: 'firePlace',
                        iconName: 'hotel-fireplace',
                        title: 'Fire Place'
                    },
                    {
                        code: 'ironInRoom',
                        desc: 'RMA: iron (55); ironing board (56);',
                        iconName: 'hotel-iron',
                        title: 'Iron in Room'
                    },
                    {
                        code: 'safeInRoom',
                        desc: 'RMA: safe (92);',
                        iconName: 'hotel-safe',
                        title: 'Safe in Room'
                    },
                    {
                        code: 'sittingArea',
                        desc: 'RMA: sitting area (99); recliner (87); family oversized room (185);',
                        iconName: 'hotel-couch',
                        title: 'Sitting Area'
                    },
                    {
                        code: 'washerAndDryer',
                        desc: 'RMA: washer/dryer (149);',
                        iconName: 'hotel-laundry',
                        title: 'Onsite Laundry'
                    }
                ]
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/components/pages/pages/FormStructure.js